export const THEME_MODE = {
  DARK: "dark",
  LIGHT: "light",
};
